import EXPORTER_PRIVATE_PATH from "@/src/routes/exporter/path";
import IMPORTER_PRIVATE_PATH from "@/src/routes/importer/path";
import PUBLIC_PATH from "@/src/routes/public/path";
import { useAppDispatch, useAppSelector } from "@/src/store";
import { setRedirectUrl } from "@/src/store/slice/auth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useNormalizedUser } from "@/src/hooks/useNormalizedUser";

const ProtectedPublicRoute = () => {
  const { user, redirectUrl, token, isLoginRedirectComplete } = useAppSelector((state) => state.auth);
  const normalizedUser = useNormalizedUser(user);
  const dispatch = useAppDispatch();
  const search = useLocation();

  useEffect(() => {
    if (user && redirectUrl) {
      dispatch(setRedirectUrl(null));
    }
  }, [user, redirectUrl, dispatch]);

  if (user) {
    if (redirectUrl) {
      return <Navigate to={redirectUrl} replace />;
    }

    if (normalizedUser?.isAccountUser && user && "hasExporterUser" in user && user.hasExporterUser === false) {
      const isOnSignupFlow =
        search.pathname === PUBLIC_PATH.SIGNUP ||
        search.pathname === PUBLIC_PATH.SIGNUP_MEMBER ||
        search.pathname === PUBLIC_PATH.SIGNUP_MEMBER_RESULT ||
        search.pathname === PUBLIC_PATH.SIGNUP_PENDING_APPROVAL ||
        search.pathname === PUBLIC_PATH.SIGNUP_WORKSPACE ||
        search.pathname === PUBLIC_PATH.SIGNUP_WORKSPACE_SUCCESS;

      if (isOnSignupFlow) {
        return <Outlet />;
      }

      if (user.companyExists) {
        return <Navigate
          to={PUBLIC_PATH.SIGNUP_MEMBER}
          state={{
            companyName: user.exporter?.companyName,
            email: user.accountDto.email,
            name: user.accountDto.name,
          }}
          replace
        />;
      } else {
        return <Navigate
          to={PUBLIC_PATH.SIGNUP_WORKSPACE}
          state={{
            email: user.accountDto.email,
            isLoggedInMode: true
          }}
          replace
        />;
      }
    }

    if (isLoginRedirectComplete) {
      if (search.pathname === EXPORTER_PRIVATE_PATH.SUBSCRIPTION_PLAN) {
        return <Outlet />;
      }

      if (token && user.exporter?.companyType === "BUYER") {
        return <Navigate to={IMPORTER_PRIVATE_PATH.HOME} replace />;
      }

      if (token && (user.exporter?.companyType === "BOTH" || user.exporter?.companyType === "SELLER")) {
        return <Navigate to={EXPORTER_PRIVATE_PATH.HOME} replace />;
      }
    }

    if (token && search.pathname === PUBLIC_PATH.ROOT && normalizedUser?.isExporterUser) {
      return <Navigate to={EXPORTER_PRIVATE_PATH.HOME} replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedPublicRoute;
